// CTO Endpoints Constants
export const CTO_ENDPOINTS = {
  // CTO Summary
  CTO_SUMMARY: "/cto-summary",

  // Vessel CTO Operations
  VESSEL_CTOS: (vesselCode: string) => `/vessels/${vesselCode}/ctos`,
  VESSEL_CTO_CREATE: (vesselCode: string) => `/vessels/${vesselCode}/ctos`,
  VESSEL_CTO_DETAIL: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}`,
  VESSEL_CTO_LEGACY: (vesselCode: string) => `/vessel/${vesselCode}/cto`,
  VESSEL_CTO_CLOSE: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/close`,
  VESSEL_CTO_EXTEND: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/extend-date`,
  VESSEL_CTO_EXPIRY_DATE_HISTORY: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/expiry-date/history`,
  VESSEL_CTO_EXPORT: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/export`,
  VESSEL_CTO_GROUPING_DECISION_ELIGIBLE: (vesselCode: string, ctoId: string) =>
    `/vessel/${vesselCode}/cto/${ctoId}/grouping-decision/eligible`,
  VESSEL_CTO_GROUPING_DECISION_SELECT: (vesselCode: string, ctoId: string) =>
    `/vessel/${vesselCode}/cto/${ctoId}/grouping-decision/select`,

  // CTO Steps
  VESSEL_CTO_INITIATION: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/initiation`,
  VESSEL_CTO_BARRIER_TRIAGE: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/initiation/triage`,
  VESSEL_CTO_EVALUATION: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/evaluation`,
  VESSEL_CTO_EVALUATION_AFFECTED_AREAS: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/evaluation/affected-areas`,
  VESSEL_CTO_EVALUATION_MDB: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/evaluation/risk-assessment`,
  VESSEL_CTO_EVALUATION_RISK_ASSESSMENT_COMPLEMENT: (
    vesselCode: string,
    ctoCode: string,
  ) => `/vessel/${vesselCode}/cto/${ctoCode}/evaluation/risk-assessment/complement`,
  VESSEL_CTO_DECISION: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/decision`,
  VESSEL_CTO_REVIEW: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/review`,
  VESSEL_CTO_APPROVAL: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/approval`,
  VESSEL_CTO_RECOMMENDATIONS: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/recommendations`,
  VESSEL_CTO_REASSESSMENT: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/reassessment`,
  VESSEL_CTO_VERIFICATION: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/verification`,
  VESSEL_CTO_CLOSURE: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/closure`,
  VESSEL_CTO_INITIATION_APPROVE: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/initiation/approve`,
  VESSEL_CTO_REVIEW_APPROVE: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/review/approve`,
  VESSEL_CTO_CLOSURE_APPROVE: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/closure/approve`,

  // Recommendations Implementation
  VESSEL_CTO_RECOMMENDATION_IMPLEMENTATION: (
    vesselCode: string,
    ctoCode: string,
    recommendationId: number,
  ) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/recommendation/${recommendationId}/implementation`,

  // Recommendations
  VESSEL_RECOMMENDATIONS: (vesselCode: string) =>
    `/vessel/${vesselCode}/recommendation`,
  VESSEL_RECOMMENDATION_SUMMARY: (vesselCode: string) =>
    `/vessel/${vesselCode}/recommendation-summary`,
  VESSEL_RECOMMENDATION_EXTEND: (
    vesselCode: string,
    ctoCode: string,
    recommendationId: number,
  ) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/recommendation/${recommendationId}/extend`,
  VESSEL_RECOMMENDATION_DUE_DATE_HISTORY: (
    vesselCode: string,
    ctoCode: string,
    recommendationId: number,
  ) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/recommendation/${recommendationId}/due-date-history`,

  // Status
  VESSELS_CTOS_STATUS: (vesselCode: string) =>
    `/vessels/${vesselCode}/ctos/status`,
  VESSEL_CTO_STATUS: (vesselCode: string) => `/vessel/${vesselCode}/cto/status`,

  // Contingency Plan
  VESSEL_CONTINGENCY_PLAN: (vesselCode: string) =>
    `/vessel/${vesselCode}/contingency-plan`,
  VESSEL_CONTINGENCY_PLAN_ITEM: (
    vesselCode: string,
    contingencyPlanCode: string,
  ) => `/vessel/${vesselCode}/contingency-plan/${contingencyPlanCode}`,

  // Mitigation Protocol
  VESSEL_MITIGATION_PROTOCOL_ASSIGN: (vesselCode: string, ctoCode: string) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/mitigation_protocol/assign`,
  VESSEL_MITIGATION_PROTOCOL_RECOMMENDATION: (
    vesselCode: string,
    ctoCode: string,
    recommendationId: number,
  ) =>
    `/vessel/${vesselCode}/cto/${ctoCode}/mitigation_protocol/recommendation/${recommendationId}`,

  // Generic
  VESSEL_GENERIC: (vesselCode: string) => `/vessels/${vesselCode}/**`,
  VESSEL_CTO_STEP: (
    vesselCode: string,
    ctoCode: string,
    stepSubdirectory: string,
  ) => `/vessel/${vesselCode}/cto/${ctoCode}/${stepSubdirectory}`,
} as const;
